<template>
  <b-modal id="modal-2" size="xl">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div>
          <!-- <i class="fa fa-2x fa-orange fa-exclamation-triangle mb-3 slow-spin animated"></i> -->
          <i class="fa fa-2x fa-orange fa-exclamation-triangle mb-3"></i>
        </div>
      </div>
    </template>

    <!--Body-->
    <div class="modal-body">
      <b-row>
        <b-col sm="12">
          <b-table
            :items="zip.active_conflicts"
            :fields="fields"
            hover
            small
            fixed
            caption
            selectable
            select-mode="single"
            responsive="sm"
            selectedVariant="success"
          ></b-table>
        </b-col>
      </b-row>
    </div>

    <!--Footer-->
    <template slot="modal-footer">
      <div slot class="modal-footer justify-content-center" style="border:none;">
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="outline-primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-2')"
          aria-label="Close"
        >Close</b-button>
      </div>
    </template>

    <!--/.Content-->
  </b-modal>
</template>

<script>
import cTable from "@/views/base/Table.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: { cTable },
  data() {
    return {
      conflicts_instance: this.conflicts,
      fields: [
        {
          key: "SeminarID",
          label: "ID",
          sortable: true,
          thStyle: "width: 5%;"
        },
        {
          key: "Territory.TerritoryName",
          label: "Territory",
          sortable: true
        },
        {
          key: "Seatings[0].DateOfSeating",
          label: "Date 1",
          sortable: true
        },
        {
          key: "Seatings[1].DateOfSeating",
          label: "Date 2",
          sortable: true
        },
        {
          key: "Seatings[2].DateOfSeating",
          label: "Date 3",
          sortable: true
        },
        {
          key: "Seatings[3].DateOfSeating",
          label: "Date 4",
          sortable: true
        },
         {
          key: "Seatings[4].DateOfSeating",
          label: "Date 5",
          sortable: true
        },
         {
          key: "Seatings[5].DateOfSeating",
          label: "Date 6",
          sortable: true
        },
        {
          key: "Seatings[0].Restaurant.Name",
          label: "Restaurant",
          sortable: true
        }
      ]
    };
  },
  computed: {
    ...mapState(["seminar", "zip"])
  },
  methods: {},
  created() {
    //console.log(this.conflicts);
  },

  props: {
    conflicts: { type: Array }
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
</style>
